<template>
	<Teleport to="body">
		<transition name="fade">
			<div v-if="status" class="qr-reader-container">
				<qrcode-stream :paused="paused" :track="onTrack" @detect="onDetect" @camera-on="onCameraOn"
					@camera-error="onCameraError"></qrcode-stream>
				<MaoButton class="close-button" variant="opacity-light" icon="close" @click="turnOffCamera"></MaoButton>

			</div>
		</transition>
		<transition name="fade">
			<div class="confirmation-background" v-if="decodedValue">
				<div class="confirmation">
					<div class="artwork-found">{{decodedValue.title}}</div>
					<MaoButton @click="goToArtwork" :label="labels['Go to Artwork']"></MaoButton>
				</div>

			</div>
		</transition>
	</Teleport>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import { useAppDataStore } from './../stores/appData'
import MaoButton from './MaoButton.vue'

export default {
	name: 'QrScanner',
	components: { QrcodeStream, MaoButton },
	props: {
		status: { type: Boolean, default: false }
	},

	data() {
		return {
			appDataStore: useAppDataStore(),
			decodedValue: null,
			lastRawValue: null,
			hideTimer: null,
			paused: false,
			HIDE_DELAY: 1000
		}
	},

	computed: {
		labels() {
			return this.appDataStore.appData.labels
		}
	},

	methods: {
		clearHideTimer() {
			if (this.hideTimer) {
				clearTimeout(this.hideTimer)
				this.hideTimer = null
			}
		},
		armHideTimer() {
			this.clearHideTimer();
			this.hideTimer = setTimeout(() => {
				this.decodedValue = null;
				this.lastRawValue = null;
				this.paused = true;
				setTimeout(() => {
					this.paused = false;
				}, 1);
			}, this.HIDE_DELAY)
		},

		onTrack(codes) {
			if (codes && codes.length) this.armHideTimer()
		},

		onDetect(codes) {
			if (!codes || codes.length === 0) return;
			this.armHideTimer();

			const rawUrl = codes[0].rawValue.trim()
			if (rawUrl === this.lastRawValue) return;
			this.lastRawValue = rawUrl;

			const match = rawUrl.match(/artwork\/(\d+)/);

			if (!match) {
				confirm('Stai per visitare un contenuto esterno. Vuoi continuare?') ? window.open(rawUrl, '_blank') : null;
				return;
			}

			const artworkIdToFind = match[1];

			for (let artwork of this.appDataStore.appData.artworks) {
				if (parseInt(artwork.translations.it) == parseInt(artworkIdToFind)) {
					this.decodedValue = artwork;
					break;
				}
			}
			
			return;
		},

		goToArtwork() {
			if (!this.decodedValue) return;

			const currentPath = this.$route.name;
			if (currentPath === 'PathArtwork') {
				console.log(this.$route);
				return;
			}

			this.$router.push({ name: 'Artwork', params: { id: this.decodedValue.id } })
			setTimeout(() => {
				this.decodedValue = null
				this.$emit('update:status', false)
			}, 500)
		},

		turnOffCamera() {
			this.$emit('update:status', false)
		},

		onCameraError(err) {
			console.error('Errore fotocamera:', err)
			alert('Impossibile accedere alla fotocamera. Controlla i permessi.')
			this.turnOffCamera()
		}
	},

	beforeUnmount() {
		this.clearHideTimer();
		this.decodedValue = null;
	}
}
</script>

<style scoped lang="scss">
.qr-reader-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background-color: black;
}

.close-button {
	position: fixed;
	top: 1rem;
	z-index: 100;
	right: 0.9rem;

	@include breakpoint(xs) {
		top: 0.7rem;
		right: 0.7rem;
	}
}

.start-button {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
}

.confirmation-background {
	position: fixed;
	inset: 0;
	z-index: 1000;

	.confirmation {
		position: absolute;
		bottom: 0;
		top: 0;
		width: 80%;
		left: 50%;
		transform: translateX(-50%);
		height: 100%;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		padding-bottom: 2rem;
		
		p {
			color: #333;
			font-size: 1.2em;
		}

		Button {
			margin: 20px;
		}
	}

	&::after {
		content: '';
		pointer-events: none;
		inset: 0;
		position: fixed;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: -1;
	}


}

.artwork-found {
	width: 100%;
	bottom: 1rem;
	text-align: center;
	color: white;
}
</style>
